import { Component, EventEmitter, Inject, Output, signal } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BuildupService } from 'src/app/models/order';
import { HttpOrderService } from 'src/app/services/http/order.service';

export interface SelectedBuildupServiceInterface {
  assembly: BuildupService | null,
  enteredPostalcode: string
}

@Component({
    selector: 'gea-shop-buildup-service',
    templateUrl: './buildup-service.component.html',
    styleUrls: ['./buildup-service.component.scss'],
    standalone: false
})
export class BuildupServiceComponent {

  buildupService = signal<BuildupService | null | undefined>(undefined)
  postalcode?: string

  notfound: boolean = false
  errorMsg = signal<string | undefined>(undefined)

  form: FormGroup
  fb: FormBuilder

  @Output("checkBuildup") checkBuildUpEvent = new EventEmitter<SelectedBuildupServiceInterface | undefined>()

  constructor(
    @Inject(HttpOrderService) public orderService: HttpOrderService,
    fb: FormBuilder
  ) {
    this.fb = fb
    this.form = fb.group({
      postalcode: [this.postalcode],
    })
  }

  ngAfterViewInit(): void {
    document.getElementById("postalcodeInput")?.focus()
  }

  checkBuildupService(value: any, isSubmit: boolean) {
    let postalcode: string = value.postalcode + ''
    postalcode = postalcode.trim()

    if(! postalcode || postalcode.length < 4) {
      if(isSubmit) {
        this.errorMsg.set("Keine gültige Postleitzahl.")
      }
      return
    }

    this.orderService.getBuildupService(postalcode).subscribe(assembly => {
      this.buildupService.set(assembly)
      this.notfound = (assembly == null)

      if(this.notfound) {
        this.errorMsg.set("In dieser Region nicht verfügbar.")
      } else {
        this.errorMsg.set(undefined)
      }

      if(isSubmit) {
        this.checkBuildUpEvent.emit({
          assembly: assembly,
          enteredPostalcode: postalcode
        })
      }
    })
  }
  
}
